import React, { useState, useRef, useEffect } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";


const APP_ID = "87c93926de6a42c1b5ccefacb864c629"; 
const CHANNEL_NAME = "video-calling"; 
const TEMP_TOKEN = "007eJxTYJhfrFRcpcCx8OKDCLfNWXWNDZn3lX4+MUjsVE6PjjG846jAYGGebGlsaWSWkmqWaGKUbJhkmpycmpaYnGRhZpJsZmQprNia3hDIyGBVO5uJkQECQXxehrLMlNR83eTEnJzMvHQGBgAg3yF6"; // Replace with your temporary token
function Videoforcall() {
  const [joined, setJoined] = useState(false);
  const [remoteUsers, setRemoteUsers] = useState([]);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const client = useRef(null);
  const localTrack = useRef(null);

  // Initialize the Agora client
  useEffect(() => {
    client.current = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

    client.current.on("user-published", handleUserPublished);
    client.current.on("user-unpublished", handleUserUnpublished);

    return () => {
      if (client.current) {
        client.current.leave();
        client.current = null;
      }
    };
  }, []);

  const joinChannel = async () => {
    try {
      // Join channel
      await client.current.join(APP_ID, CHANNEL_NAME, TEMP_TOKEN, null);

      // Create a local video track and play it
      const track = await AgoraRTC.createCameraVideoTrack();
      localTrack.current = track;
      track.play(localVideoRef.current);

      // Publish the local video track
      await client.current.publish([track]);

      setJoined(true);
    } catch (error) {
    }
  };

  const leaveChannel = async () => {
    try {
      // Stop the local video track
      if (localTrack.current) {
        localTrack.current.stop();
        localTrack.current.close();
      }

      // Leave the channel
      await client.current.leave();

      setRemoteUsers([]);
      setJoined(false);
    } catch (error) {
    }
  };

  const handleUserPublished = async (user, mediaType) => {
    try {
      await client.current.subscribe(user, mediaType);

      if (mediaType === "video") {
        setRemoteUsers((prev) => [...prev, user]);
        user.videoTrack.play(remoteVideoRef.current);
      }
    } catch (error) {
    }
  };

  const handleUserUnpublished = (user) => {
    setRemoteUsers((prev) => prev.filter((u) => u.uid !== user.uid));
  };

  return (
    <>
      <div>
        <h1>Agora Video Call</h1>
        <div style={{ display: "flex", gap: "20px" }}>
          <div>
            <h2>Local Video</h2>
            <div
              ref={localVideoRef}
              style={{ width: "400px", height: "300px", background: "#ccc" }}
            ></div>
          </div>
          <div>
            <h2>Remote Video</h2>
            <div
              ref={remoteVideoRef}
              style={{ width: "400px", height: "300px", background: "#eee" }}
            ></div>
          </div>
        </div>
        <div>
          {!joined ? (
            <button onClick={joinChannel}>Join Channel</button>
          ) : (
            <button onClick={leaveChannel}>Leave Channel</button>
          )}
        </div>
      </div>
    </>
  );
}

export default Videoforcall;
